import React, { memo, useMemo, useContext } from 'react';
import cx from 'classnames';

import { PreviewComponentProps } from '../../EmailTemplatePreview';
import EditorContext, { EditorContextProps } from '../../Context';
import Cta from '../Components/Cta';
import VideoPreview from '../Components/VideoPreview';
import ChatBubble from '../Components/ChatBubble';
import { getTimestamp } from '~/utils/date';
import Disclaimer from '../Components/Disclaimer';
import Logo from '../Shared/Logo';
import Sender from '../Components/Sender';
import Footer from '../Components/Footer';
import Banner from '../Components/Banner';
import { useVmPlan } from '~/react-hooks/use-plans';

const Html2 = memo(
  ({
    name,
    bio,
    image,
    playerImage,
    theme,
    logoUrl,
    children,
    hidePreviewTag,
    bannerContent,
    disclaimerContent,
  }: PreviewComponentProps) => {
    const editorContext: EditorContextProps = useContext(EditorContext);
    const { isFreePlan } = useVmPlan();

    const { preview } = editorContext;
    const isMobile = useMemo(() => {
      return preview === 'mobile';
    }, [preview]);

    return (
      <div
        className={cx({
          'mx-14': !isMobile,
        })}
      >
        {name && <Banner sender={name} content={bannerContent} />}
        {logoUrl && <Logo logoUrl={logoUrl} />}
        <div
          className={cx(
            'mt-0 mx-auto mb-10 text-xs rounded-md px-0 pt-6 pb-12 border border-solid',
            {
              'border-white': isMobile,
              'border-neutral-300': !isMobile,
            }
          )}
        >
          <div className={`m-auto w-[${isMobile ? '250px' : '350px'}]`}>
            <Sender
              image={image}
              name={name}
              bio={bio}
              subtitle={`Recorded on ${getTimestamp()} UTC`}
              avatarClassName='pr-1.5'
            />
            <VideoPreview
              thumbnail={playerImage}
              hidePreviewTag={hidePreviewTag}
              className='pt-3'
            />
            <Cta
              text='Watch your video'
              bgColor={theme?.primaryColor}
              textColor={theme?.secondaryColor}
              className='pt-4'
            />
            <ChatBubble chatBubbleClassName='!bg-transparent p-0 text-neutral-700'>
              {children}
            </ChatBubble>
          </div>
        </div>
        <Disclaimer className='text-center' contents={disclaimerContent} />
        {isFreePlan && <Footer />}
      </div>
    );
  }
);

export default Html2;
